import { CSSObject } from '@emotion/react';
import { theme } from '@frontend/theme';

export const voiceAiActivityAccordionStyles = {
  container: (attachedToCallBubble: boolean): CSSObject => ({
    marginTop: attachedToCallBubble ? theme.spacing(1) : theme.spacing(0.5),
    width: '100%',
    maxWidth: attachedToCallBubble ? '100%' : theme.spacing(34),
    borderRadius: theme.spacing(1),
    border: `0.50px solid ${theme.colors.neutral20}`,
    backgroundColor: 'rgba(255, 255, 255, 0.60)',
    overflow: 'hidden',
    transition: 'background-color 200ms ease-in-out',
    '&:hover': {
      backgroundColor: theme.colors.white,
    },
  }),
  trigger: {
    width: '100%',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1, 2, 1, 1),
    textAlign: 'left',
  } as CSSObject,
  staticTrigger: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1, 2, 1, 1),
    textAlign: 'left',
    cursor: 'default',
  } as CSSObject,
  iconWrapper: (customIconColor?: string, iconGradientBg?: string): CSSObject => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...(customIconColor
      ? {
          color: customIconColor,
        }
      : {}),
    ...(iconGradientBg
      ? {
          background: iconGradientBg,
          padding: 2,
          borderRadius: theme.spacing(0.5),
        }
      : {}),
  }),
  collapsedLabel: {
    color: theme.colors.neutral90,
    fontSize: theme.fontSize(12),
    lineHeight: 1.3,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  } as CSSObject,
  hiddenCount: {
    color: theme.colors.neutral70,
    fontSize: theme.fontSize(12),
    marginLeft: 'auto',
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.25, 0.5),
    backgroundColor: theme.colors.neutral10,
  } as CSSObject,
  chevron: (isExpanded: boolean): CSSObject => ({
    color: theme.colors.neutral70,
    marginLeft: theme.spacing(2),
    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 200ms ease-in-out',
  }),
  expandedBody: {
    overflow: 'hidden',
  } as CSSObject,
  expandedBodyContent: {
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.colors.white,
  } as CSSObject,
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1, 0, 1, 1),
    '&:not(:last-of-type)': {
      borderBottom: `0.50px solid ${theme.colors.neutral10}`,
    },
    '&:first-of-type': {
      paddingTop: theme.spacing(0),
    },
  } as CSSObject,
  rowText: {
    color: theme.colors.neutral90,
    fontSize: theme.fontSize(12),
    lineHeight: 1.35,
    overflowWrap: 'anywhere',
  } as CSSObject,
};
